import React, { Component } from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleMonthYearPicker, {
  convertToDateObject,
} from "../../../modules/SimpleMonthYearPicker";
import SimpleDDL from "../../../modules/SimpleDDL";
import { fetchDataAsync } from "../../../Services/Utils";
import Api from "../../../Services/Api";
import {
  ACTIVITY_TYPE,
  GenericSequenceType,
  HttpStatus,
  INITIAL_DATE,
  Status,
} from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import {
  DDL_RANKING,
  INITIAL_DATA_PO_FIX,
  INITIAL_DATA_PO_TENT,
} from "./constant";
import PoTable from "./poTable";
import moment from "moment";
import debounce from "lodash.debounce";
import { saveAs } from "file-saver";
import SimpleMonthYearPickerWithIcon from "../../../modules/SimpleMonthYearPickerWithIcon";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";

class PoPartDetail extends Component {
  constructor(props) {
    super(props);
    this.debouncedFetch = debounce((tableName, name, index) => {
      this.fetchUpdateTemporaryTablePO(tableName, name, index);
    }, 500);
    this.state = {
      data: {
        poDate: INITIAL_DATE,
        bulanTahunBerlaku: null,
        cabang: this.props.kodeCabang,
        namaMd: null,
        kategoriPart: null,
        rankFilter: null,
        poFix: [],
        poTen1: [],
        poTen2: [],
      },
      tempNoPo: null,
      partCategoryOptions: [],
      kodeSupplierMD: [],
      partOptions: [], //as source data
      ddlPart: [], // yang ditampilkan
      alertRankModalVisible: false,
      pendingRankFilter: null,
      pendingCategory: null,
      pendingBulanTahun: null,
      confirmDeleteVisible: false,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevCategory = prevState.data?.kategoriPart?.value;
    const currCategory = this.state.data?.kategoriPart?.value;
    if (currCategory && prevCategory !== currCategory) {
      this.fetchPartByCategory(currCategory);
    }

    const currBulanTahun = this.state.data.bulanTahunBerlaku;
    const prevBulanTahun = prevState.data.bulanTahunBerlaku;
    const currRankLimit = this.state.data.rankFilter?.value;
    const prevRankLimit = prevState.data.rankFilter?.value;

    if (currBulanTahun && currCategory) {
      if (
        currRankLimit &&
        (currRankLimit !== prevRankLimit ||
          currCategory !== prevCategory ||
          currBulanTahun?.format("MMMM YYYY") !==
            prevBulanTahun?.format("MMMM YYYY"))
      ) {
        // this.fetchRankingPoPart(currRankLimit);
        // this.confirmFetchRanking(currRankLimit)
      }
    }
  }

  fetchNoPo = async () => {
    const { setError, kodeCabang } = this.props;
    const resNoPo = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave,
      menuName: "PO Part",
      setError,
      args: {
        seqType: GenericSequenceType.TRANSACTION_PO_PART,
        nosDealerCode: kodeCabang?.value,
        transactionType: GenericSequenceType.TRANSACTION_PO_PART,
      },
    });
    if (resNoPo.ok) {
      this.setState({
        tempNoPo: resNoPo.data,
      });
    }
  };

  fetchPartByCategory = async (value) => {
    const { onTriggerLoading, setError } = this.props;
    onTriggerLoading();

    let categoryPayload;
    if (value === "ALL") {
      categoryPayload = this.state.partCategoryOptions
        .filter((opt) => opt.value !== "ALL")
        .map((opt) => opt.value);
    } else {
      categoryPayload = [value];
    }
    console.log(categoryPayload);

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPoPartListByListCategory,
      menuName: "PO Part",
      setError,
      args: categoryPayload,
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        partOptions: res.data.data,
      }));
    }
  };

  fetchDataPo = async (id) => {
    const { setError } = this.props;
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getPoPartById,
      menuName: "PO Part -aw",
      setError,
      args: {
        id: id,
      },
    });

    if (res?.ok && res?.data?.status === HttpStatus.SUCCESS) {
      const data = res.data.data;
      this.setState((prev) => ({
        ...prev,
        data: {
          id: data.id,
          namaMd: mapToObjectDDL(data.mainDealerName, data.getMainDealerCode),
          kategoriPart: mapToObjectDDL(
            data.partCategoryName,
            data.partCategoryCode
          ),
          cabang: mapToObjectDDL(data.cabangName, data.kodeCabang),
          bulanTahunBerlaku: convertToDateObject(data.monthDate),
          poDate: data.poDate,
          poPartId: data.poPartId,
          rankFilter: mapToObjectDDL(data.rank, data.rank),
          poFix: data.dataFixPO?.map((item) => ({
            ...item,
            namaPart: mapToObjectDDL(item.partName, item.partCode),
            kodePart: mapToObjectDDL(item.partCode, item.partCode),
            isSaved: true,
          })),
          poTen1: data.tent1?.map((item) => ({
            ...item,
            namaPart: mapToObjectDDL(item.partName, item.partCode),
            kodePart: mapToObjectDDL(item.partCode, item.partCode),
            isSaved: true,
          })),
          poTen2: data.tent2?.map((item) => ({
            ...item,
            namaPart: mapToObjectDDL(item.partName, item.partCode),
            kodePart: mapToObjectDDL(item.partCode, item.partCode),
            isSaved: true,
          })),
        },
      }));
    }
  };

  loadData = async () => {
    const { onTriggerLoading, setError, kodeCabang, selectedData } = this.props;
    onTriggerLoading();

    if (!selectedData) {
      await this.fetchNoPo();
    } else {
      await this.fetchDataPo(selectedData);
    }

    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
        menuName: "PO Part",
        setError,
        args: {
          paramFilters: {
            bizparCategory: "PART_TYPE",
            status: Status.ACTIVE,
          },
        },
      }),
    ];
    if (!selectedData) {
      promises.push(
        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSupplier,
          menuName: "PO Part",
          setError,
          args: {
            jenisSupplier: "SPL03",
            cabang: [kodeCabang?.value],
            status: Status.ACTIVE,
          },
        })
      );
    }
    const responses = await Promise.all(promises);
    onTriggerLoading();
    responses.forEach((res, index) => {
      if (index === 0 && res.ok && res.data.status === HttpStatus.SUCCESS) {
        const mappedOptions = res.data.data.map((item) =>
          mapToObjectDDL(item.value, item.key)
        );
        
        this.setState({
          partCategoryOptions: [
            { label: "ALL", value: "ALL" },
            ...mappedOptions,
          ],
        });
      }
      if (
        !selectedData &&
        index === 1 &&
        res.ok &&
        res.data.status === HttpStatus.SUCCESS
      ) {
        this.handleSetData(
          "namaMd",
          mapToObjectDDL(
            res.data.data[0]?.supplierName,
            res.data.data[0]?.supplierCode
          )
        );
      }
    });
  };

  mapResponse = (data) => {
    return data.map((item) => {
      const { partCode, partName, ...rest } = item;
      return {
        ...rest,
        namaPart: mapToObjectDDL(partName, partCode),
        kodePart: mapToObjectDDL(partCode, partCode),
        isSaved: true,
      };
    });
  };

  fetchRankingPoPart = async (limit) => {
    const { onTriggerLoading, setError } = this.props;
    const { data } = this.state;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getRankingForPOPartDTO,
      menuName: "PO Part",
      setError,
      args: {
        kodeCabang: data?.cabang?.value,
        limit: limit.value,
        categoryPart: data.kategoriPart?.value,
        year: data.bulanTahunBerlaku.format("YYYY"),
        month: data.bulanTahunBerlaku.format("MMMM YYYY"),
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          poFix: this.mapResponse(res?.data?.data?.poFix || []),
          poTen1: this.mapResponse(res?.data?.data?.tent1 || []),
          poTen2: this.mapResponse(res?.data?.data?.tent2 || []),
        },
      }));
    }
  };

  handleSetData = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [name]: value,
      },
    }));
  };

  handleAddData = () => {
    const { data } = this.state;
    const { onTriggerAlert } = this.props;
    if (!data.kategoriPart?.value) {
      onTriggerAlert(
        "Informasi",
        "Kategori Part Belum Dipilih. Harap Isi Terlebih Dahulu"
      );
      return;
    }
    this.setState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        poFix: [...prev.data.poFix, INITIAL_DATA_PO_FIX],
        poTen1: [...prev.data.poTen1, INITIAL_DATA_PO_TENT],
        poTen2: [...prev.data.poTen2, INITIAL_DATA_PO_TENT],
      },
    }));
  };

  handleDeleteRow = (rowIndex) => {
    this.setState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        poFix: prev?.data?.poFix?.filter((_, index) => index !== rowIndex),
        poTen1: prev?.data?.poTen1?.filter((_, index) => index !== rowIndex),
        poTen2: prev?.data?.poTen2?.filter((_, index) => index !== rowIndex),
      },
    }));
  };

  handleSelectPart = (index, name, value) => {
    this.setState((prev) => {
      const newPoFix = [...prev.data.poFix];
      const newTen1 = [...prev.data.poTen1];
      const newTen2 = [...prev.data.poTen2];

      newPoFix[index] = {
        ...newPoFix[index],
        [name]: value,
      };
      newTen1[index] = {
        ...newTen1[index],
        [name]: value,
      };
      newTen2[index] = {
        ...newTen2[index],
        [name]: value,
      };
      return {
        ...prev,
        data: {
          ...prev.data,
          poFix: newPoFix,
          poTen1: newTen1,
          poTen2: newTen2,
        },
      };
    });
  };

  handleResetPart = (index, name, value) => {
    this.setState((prev) => {
      return {
        ...prev,
        data: {
          ...prev.data,
          poFix: [],
          poTen1: [],
          poTen2: [],
        },
      };
    });
  };

  handleGetTemporaryPoPart = async (kodePart, index) => {
    const { onTriggerLoading, setError, onTriggerAlert } = this.props;
    const { data } = this.state;

    if (!data.bulanTahunBerlaku) {
      onTriggerAlert(
        "Informasi",
        "Bulan Tahun Berlaku Belum Dipilih. Harap Isi Terlebih Dahulu"
      );
      return;
    }
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getPoPartTem,
      menuName: "PO Part",
      setError,
      args: {
        kodeCabang: data?.cabang?.value,
        month: data?.bulanTahunBerlaku.format("MMMM YYYY"),
        kodePart: kodePart,
        categoryCode: data?.kategoriPart?.value,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => {
        const newPoFix = [...prev.data.poFix];
        const newTen1 = [...prev.data.poTen1];
        const newTen2 = [...prev.data.poTen2];

        newPoFix[index] = {
          ...newPoFix[index],
          ...res.data.data.dataFixPO,
        };
        newTen1[index] = {
          ...newTen1[index],
          ...res.data.data.tent1,
        };
        newTen2[index] = {
          ...newTen2[index],
          ...res.data.data.tent2,
        };
        return {
          ...prev,
          data: {
            ...prev.data,
            poFix: newPoFix,
            poTen1: newTen1,
            poTen2: newTen2,
          },
        };
      });
    }
  };

  handleChangeTableValue = (index, name, value, tableName) => {
    this.setState((prev) => {
      const newData = [...prev.data[tableName]];

      newData[index] = {
        ...newData[index],
        [name]: Number(value),
      };
      return {
        ...prev,
        data: {
          ...prev.data,
          [tableName]: newData,
        },
      };
    });

    this.debouncedFetch(tableName, name, index);
  };

  fetchUpdateTemporaryTablePO = async (tableName, fieldName, index) => {
    const { onTriggerLoading, setError } = this.props;
    const { data } = this.state;

    const { namaPart, kodePart, isSaved, ...rest } = data?.poFix[index];

    const {
      namaPart: namaPartP1,
      kodePart: kodePartP1,
      isSaved: saved1,
      ...restP1
    } = data?.poTen1[index];
    const {
      namaPart: namaPartP2,
      kodePart: kodePartP2,
      isSaved: saved2,
      ...restP2
    } = data?.poTen2[index];

    const payload = {
      poDate: moment().format("DD-MM-YYYY"),
      dataFixPO: {
        ...rest,
        partName: namaPart?.label,
        partCode: kodePart?.value,
      },
      tent1: {
        ...restP1,
        partName: namaPartP1?.label,
        partCode: kodePartP1?.value,
      },
      tent2: {
        ...restP2,
        partName: namaPartP2?.label,
        partCode: kodePartP2?.value,
      },
      proyeksiSalesMtdManualInput:
        tableName === "poFix" && fieldName === "salesProjectionMtd",
      proyeksiSales2BulanManualInput:
        tableName === "poFix" && fieldName === "salesProjectionTwoMonthsLater",
      qtyPoFixManualInput: tableName === "poFix" && fieldName === "qtyPoReal",
      targetTentative1ManualInput:
        tableName === "poTen1" && fieldName === "salesTarget",
      qtyPoTentative1ManualInput:
        tableName === "poTen1" && fieldName === "potentativeReal",
      targetTentative2ManualInput:
        tableName === "poTen2" && fieldName === "salesTarget",
      qtyPoTentative2ManualInput:
        tableName === "poTen2" && fieldName === "potentativeReal",
    };
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getTemporaryDataForPOEdit,
      menuName: "PO Part",
      setError,
      args: payload,
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => {
        const newPoFix = [...prev.data.poFix];
        const newTen1 = [...prev.data.poTen1];
        const newTen2 = [...prev.data.poTen2];

        const { partCode, partName, ...rest } = res.data.data.dataFixPO;
        const { partCode: pc1, partName: pn1, ...r1 } = res.data.data.tent1;
        const { partCode: pc2, partName: pn2, ...r2 } = res.data.data.tent2;

        newPoFix[index] = {
          ...newPoFix[index],
          ...rest,
        };
        newTen1[index] = {
          ...newTen1[index],
          ...r1,
        };
        newTen2[index] = {
          ...newTen2[index],
          ...r2,
        };
        return {
          ...prev,
          data: {
            ...prev.data,
            poFix: newPoFix,
            poTen1: newTen1,
            poTen2: newTen2,
          },
        };
      });
    }
  };

  handleSubmitData = async () => {
    const { data } = this.state;
    const {
      onTriggerLoading,
      setError,
      onClickClose,
      onRefresh,
      onTriggerAlert,
    } = this.props;
    
    const bulanValidation = await this.validateBulanBerlaku();
    if (bulanValidation?.type === "kategori" || bulanValidation?.type === "bulanKosong") {
      return;
    }
    if (bulanValidation?.type === "bulan") {
      onTriggerAlert(
        "Informasi",
        `PO dengan kategori part ${data.kategoriPart?.label} tidak dapat dibuat pada periode bulan yang sama!`
      );
      return;
    }
    if (
      !data.poFix?.length ||
      !data.poTen1?.length ||
      !data.poTen2?.length
    ) {
      onTriggerAlert(
        "Informasi",
        "Data PO Fix, Tentative 1, dan Tentative 2 tidak boleh kosong!"
      );
      return; 
    }
    
    const payload = {
      poPartId: data?.poPartId || null,
      categoryPartKey: data.kategoriPart?.value,
      kodeSupplierMD: data?.namaMd?.value,
      kodeCabang: data?.cabang?.value,
      poMonth: data?.bulanTahunBerlaku?.format("MMMM YYYY"),
      poDate: moment().format("DD-MM-YYYY"),
      rank: data?.rankFilter?.value,
      poPartFix: data?.poFix?.map((item) => {
        const {
          kodePart,
          namaPart,
          isSaved,
          poPartId,
          poFixQtyLastMonth,
          ...rest
        } = item;
        return {
          ...rest,
          partCode: kodePart?.value,
          partName: namaPart?.label,
          qtyPoFixLastMonth: poFixQtyLastMonth,
        };
      }),
      poPartTentative1: data?.poTen1?.map((item) => {
        const {
          kodePart,
          namaPart,
          isSaved,
          poPartId,
          poFixQtyLastMonth,
          id,
          potentativePartId,
          potentativePartType,
          potentativeReal,
          potentativeRecommendation,
          ...rest
        } = item;
        return {
          ...rest,
          partCode: kodePart?.value,
          partName: namaPart?.label,
          qtyPoFixLastMonth: poFixQtyLastMonth,
          poTentativeReal: potentativeReal,
          poTentativeRecommendation: potentativeRecommendation,
        };
      }),
      poPartTentative2: data?.poTen2?.map((item) => {
        const {
          kodePart,
          namaPart,
          isSaved,
          poPartId,
          poFixQtyLastMonth,
          //
          id,
          potentativePartId,
          potentativePartType,
          potentativeReal,
          potentativeRecommendation,
          ...rest
        } = item;
        return {
          ...rest,
          partCode: kodePart?.value,
          partName: namaPart?.label,
          qtyPoFixLastMonth: poFixQtyLastMonth,
          poTentativeReal: potentativeReal,
          poTentativeRecommendation: potentativeRecommendation,
        };
      }),
    };
    
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").submitPoPart,
      menuName: "Po Part",
      setError,
      args: payload,
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      onTriggerAlert("Informasi", "Data Berhasil Disimpan");
      onClickClose();
      onRefresh();
    }
  };

   validatePoMonthYear = async (value) => {
    const { onTriggerLoading, setError } = this.props;
    const { data } = this.state;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkPoPart,
      menuName: "PO Part",
      setError,
      args: {
        poMonth: value,
        kodeCabang: data?.cabang?.value,
        partCategory: data?.kategoriPart.value
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      return res.data.data;
    }
    return true;
  };

  validateBulanBerlaku = async () => {
    const { data } = this.state;
    const { onTriggerAlert, activityType } = this.props;

    if (!data.kategoriPart?.value) {
      onTriggerAlert(
        "Informasi",
        "Kategori Part Belum Dipilih. Harap Isi Terlebih Dahulu"
      );
      return { error: true, type: "kategori" };
    }
    if (!data.bulanTahunBerlaku) {
      onTriggerAlert(
        "Informasi",
        "Bulan Tahun Berlaku Belum Dipilih. Harap Isi Terlebih Dahulu"
      );
      return { error: true, type: "bulanKosong" };
    }
    
    if (activityType == "CREATE") {
      const isInvalid = await this.validatePoMonthYear(
        data.bulanTahunBerlaku?.format("MMMM YYYY")
      );
      if (isInvalid === true) {
        return { error: true, type: "bulan" };
      }
      return isInvalid;
    }
  };

  handleSaveRowTable = (rowIndex) => {
    //nama part, kodepart, proyeksi sales mtd, proyeksi sales +2 month, Qty PO Real,Target Sales Tent. 1,Target Sales PO Tent. 2,Qty PO Tent. 2 Real
    const { data } = this.state;
    const { onTriggerAlert } = this.props;
    const { dataFixPO, tent1, tent2, poFix, poTent1, poTent2 } = data;
    const isInValidFixPo = dataFixPO?.find(
      (item) =>
        !item?.partName?.value ||
        !item?.partCode?.value ||
        item?.salesProjectionMtd === null ||
        item?.salesProjectionTwoMonthsLater === null ||
        item?.qtyPoReal === null
    );
    const isInValidTent1 = tent1?.find(
      (item) =>
        !item?.partName?.value ||
        !item?.partCode?.value ||
        item?.salesTarget === null ||
        item?.potentativeReal === null
    );
    const isInValidTent2 = tent2?.find(
      (item) =>
        !item?.partName?.value ||
        !item?.partCode?.value ||
        item?.salesTarget === null ||
        item?.potentativeReal === null
    );

    // const isInvalidPoFix = poFix?.some(
    //   (x) => !x.partCode || !x.kodePart?.value
    // );

    const isInvalidPoFix = poFix?.some(
      (x) => !x.namaPart?.value || !x.kodePart?.value
    );

    if (isInvalidPoFix) {
      onTriggerAlert(
        "Informasi",
        `Terdapat Data Yang Belum Lengkap. Harap Lengkapi Terlebih Dahulu!`
      );
      return;
    }
    
    if (isInValidFixPo || isInValidTent1 || isInValidTent2 ) {
      onTriggerAlert(
        "Informasi",
        `Terdapat Data Yang Belum Lengkap. Harap Lengkapi Terlebih Dahulu!`
      );
      return;
    }

    this.handleSelectPart(rowIndex, "isSaved", true);
  };


  handlePrint = async (type, tableName, fileName) => {
    const { onTriggerLoading, setError } = this.props;
    const { data } = this.state;
    console.log(data);
    
    onTriggerLoading();
    const payload = {
      poPartType: type,
      poMonth: data?.bulanTahunBerlaku?.format("MMMM YYYY"),
      category: data.kategoriPart?.label,
      poPartDetailExcel: data[tableName]?.map((item) => ({
        partName: item?.namaPart?.value,
        partCode: item?.kodePart?.value,
        qtyPoReal: item?.qtyPoReal ?? item?.potentativeReal,
      })),
    };
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION_FILE").printPoPart,
      menuName: "PO Part",
      setError,
      args: payload,
    });
    onTriggerLoading();
    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        blob,
        `${fileName}_${data.kategoriPart?.label}_${payload.poMonth}.xlsx`
      );
    }
  };

  handleShowConfirmDelete = () => {
    this.setState({ confirmDeleteVisible: true });
  };

  handleCloseConfirmDelete = () => {
    this.setState({ confirmDeleteVisible: false });
  };

  handleDelete = async () => {
    const {
      onTriggerLoading,
      setError,
      onClickClose,
      onTriggerAlert,
      onRefresh,
    } = this.props;
    const { data } = this.state;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").deletePoPart,
      menuName: "PO Part",
      setError,
      args: {
        poPartId: data?.poPartId || null,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      onTriggerAlert("Informasi", "Data Berhasil Dihapus");
      onClickClose();
      onRefresh();
    }
  };

  handleFilterDDLPart = (key) => {
    this.setState((prev) => ({
      ...prev,
      ddlPart: prev?.partOptions?.filter(
        (item) => {
          return !prev?.data[key]
            ?.map((item) => item.kodePart?.value)
            ?.includes(item.kodePart)
        }
      ),
    }));
  };

  confirmFetchRanking = (limit) => {
    this.setState({
      alertRankModalVisible: true,
      tempLimitForRanking: limit,
    });
  };

  handleAlertRankModalVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      alertRankModalVisible: !prevState.alertRankModalVisible,
    }));
  };

  render() {
    const { visible, onClickClose, activityType, onClickClosePopup } = this.props;
    const { tempNoPo, partCategoryOptions, ddlPart, data, partOptions, alertRankModalVisible  } = this.state;

    const isReadonly =
      activityType === ACTIVITY_TYPE.VIEW ||
      activityType === ACTIVITY_TYPE.DELETE;
    const isEdit = activityType === ACTIVITY_TYPE.UPDATE;
    return (
      <React.Fragment>
        <SimpleModal
          title="Detail Purchase Order"
          visible={visible}
          onClickClose={() => onClickClosePopup()}
          content={
            <ModalContainer>
              <div className="grid grid-3x grid-mobile-none gap-15px">
                <div className="column-1 gap-15px">
                  <SimpleInput
                    id="label_nomor_po"
                    name="nomorPo"
                    label="Nomor Purchase Order"
                    value={data?.poPartId || tempNoPo}
                    readOnly
                  />
                  <SimpleInput
                    id="label_tanggal_po"
                    name="tanggalPo"
                    label="Tanggal Purchase Order"
                    value={data.poDate}
                    readOnly
                  />
                </div>
                <div className="column-2 gap-15px">
                  <SimpleInput
                    id="label_cabang"
                    name="cabang"
                    label="Cabang"
                    value={data?.cabang?.label}
                    readOnly
                  />
                  <SimpleInput
                    id="label_nama_md"
                    name="namaMd"
                    label="Nama Main Dealer"
                    value={data.namaMd?.label}
                    readOnly
                  />
                </div>
                <div className="column-3 gap-15px">
                  <div className="full-month-year-picker-width">
                    <SimpleMonthYearPickerWithIcon
                      id="input_month_year_po"
                      containerclassname="width-full"
                      style={{ width: "100%" }}
                      name="bulanTahunBerlaku"
                      minDate={moment().format("YYYY/MM/DD")}
                      readOnly={isReadonly || isEdit}
                      disabled={isReadonly || isEdit}
                      label="Bulan Tahun Berlaku"
                      value={data.bulanTahunBerlaku}
                      onChange={(value) =>
                        this.handleSetData("bulanTahunBerlaku", value)
                      }
                    />
                  </div>
                  <SimpleDDL
                    id="dropdown_kategori_part"
                    name="kategoriPart"
                    label="Kategori Part"
                    box="search"
                    readOnly={isReadonly || isEdit}
                    options={partCategoryOptions}
                    value={data?.kategoriPart}
                    onChange={(value, { name }) => {
                      this.handleSetData(name, value);
                      this.handleResetPart();
                    }}
                  />
                  <SimpleDDL
                    id="dropdown_kategori_part"
                    name="rankFilter"
                    readOnly={
                      !data?.kategoriPart?.value ||
                      isReadonly ||
                      !data?.bulanTahunBerlaku ||
                      isEdit
                    }
                    label="Tampilkan Part Dengan Penjualan Teratas"
                    box="search"
                    options={DDL_RANKING}
                    value={data.rankFilter}
                    onChange={(value, { name }) => {
                      this.handleSetData(name, value);
                      this.confirmFetchRanking(value)
                    }}
                  />
                </div>
              </div>
              <Tabs
                onSelect={() => {
                  PoTable.lastPageByTab = {};
                }}
              >
                <TabList>
                  <Tab>PO Fix</Tab>
                  <Tab>PO Tent 1</Tab>
                  <Tab>PO Tent 2</Tab>
                </TabList>
                <TabPanel>
                  <PoTable
                    key={data.poFix.length}
                    {...this.props}
                    readOnly={isReadonly}
                    isEdit={isEdit}
                    dataTable={data.poFix}
                    tab="poFix"
                    onAddData={this.handleAddData}
                    partOptions={ddlPart.length > 0 ? ddlPart : partOptions}
                    onGetTempData={this.handleGetTemporaryPoPart}
                    onChangePart={this.handleSelectPart}
                    onValueChange={this.handleChangeTableValue}
                    onDeleteRow={this.handleDeleteRow}
                    onSubmit={this.handleSubmitData}
                    onSaveRow={this.handleSaveRowTable}
                    onPrint={this.handlePrint}
                    // onDelete={this.handleDelete}
                    onDelete={this.handleShowConfirmDelete}
                    onFilterDDL={() => this.handleFilterDDLPart("poFix")}
                  />
                </TabPanel>
                <TabPanel>
                  <PoTable
                    key={data.poTen1.length}
                    {...this.props}
                    readOnly={isReadonly}
                    isEdit={isEdit}
                    dataTable={data.poTen1}
                    tab="poTen1"
                    onAddData={this.handleAddData}
                    partOptions={ddlPart.length > 0 ? ddlPart : partOptions}
                    onGetTempData={this.handleGetTemporaryPoPart}
                    onChangePart={this.handleSelectPart}
                    onValueChange={this.handleChangeTableValue}
                    onDeleteRow={this.handleDeleteRow}
                    onSubmit={this.handleSubmitData}
                    onSaveRow={this.handleSaveRowTable}
                    onPrint={this.handlePrint}
                    // onDelete={this.handleDelete}
                    onDelete={this.handleShowConfirmDelete}
                    onFilterDDL={() => this.handleFilterDDLPart("poTen1")}
                  />
                </TabPanel>
                <TabPanel>
                  <PoTable
                    key={data.poTen2.length}
                    {...this.props}
                    readOnly={isReadonly}
                    isEdit={isEdit}
                    dataTable={data.poTen2}
                    tab="poTen2"
                    onAddData={this.handleAddData}
                    partOptions={ddlPart.length > 0 ? ddlPart : partOptions}
                    onGetTempData={this.handleGetTemporaryPoPart}
                    onChangePart={this.handleSelectPart}
                    onValueChange={this.handleChangeTableValue}
                    onDeleteRow={this.handleDeleteRow}
                    onSubmit={this.handleSubmitData}
                    onSaveRow={this.handleSaveRowTable}
                    onPrint={this.handlePrint}
                    // onDelete={this.handleDelete}
                    onDelete={this.handleShowConfirmDelete}
                    onFilterDDL={() => this.handleFilterDDLPart("poTen2")}
                  />
                </TabPanel>
              </Tabs>

              {
                this.state.alertRankModalVisible && (
                  <SimpleAlert
                    title={"Confirmation"}
                    content={
                      <div>
                        <p>Saat list berubah maka data yang sudah diisi akan reset.</p>
                        <p>Apakah Anda yakin ingin mengubah tampilan jumlah penjualan teratas?</p>
                      </div>
                    }
                    visible={this.state.alertRankModalVisible}
                    onClickClose={this.handleAlertRankModalVisibility}
                    additionalButtons={
                      <FlexView style={{ gap: "15px" }}>
                        <SimpleButton
                          className="margin-left-none"
                          type="button"
                          text="Tidak"
                          onClick={this.handleAlertRankModalVisibility}
                        />
                        <SimpleButton
                          className="margin-left-none"
                          type="button"
                          text="Ya"
                          onClick={() => {
                            this.handleAlertRankModalVisibility();
                            this.fetchRankingPoPart(this.state.tempLimitForRanking); 
                          }}
                        />
                      </FlexView>
                    }
                  />
                )
              }

              {
                this.state.confirmDeleteVisible && (
                  <SimpleAlert
                    title="Konfirmasi Hapus"
                    content={
                      <div>
                        <p>Apakah Anda yakin ingin menghapus data ini?</p>
                      </div>
                    }
                    visible={this.state.confirmDeleteVisible}
                    onClickClose={this.handleCloseConfirmDelete}
                    additionalButtons={
                      <FlexView style={{ gap: "15px" }}>
                        <SimpleButton
                          className="margin-left-none"
                          type="button"
                          text="Tidak"
                          onClick={this.handleCloseConfirmDelete}
                        />

                        <SimpleButton
                          className="margin-left-none"
                          type="button"
                          text="Ya"
                          onClick={() => {
                            this.handleCloseConfirmDelete();
                            this.handleDelete();    // JALANKAN DELETE SETELAH KONFIRMASI
                          }}
                        />
                      </FlexView>
                    }
                  />
                )
              }

            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default PoPartDetail;
